import { Box, Typography } from "@mui/material";
import NewPickup from "./NewPickup";

const NewPickupPage = () => {
  return (
    <Box>
      <NewPickup />
    </Box>
  );
};

export default NewPickupPage;
